import { Card, Skeleton, Space, Grid, theme } from 'antd';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';
import './style.css';

const { useBreakpoint } = Grid;

export const PlanCardSkeleton = () => {
    const screens = useBreakpoint();
    const isMobile = screens.xs;
    const { token } = theme.useToken();
    const { isDarkMode } = useTheme();

    return (
        <Card
            bordered={false}
            className={`plan-actual-card${isMobile ? ' mobile-card' : ''}`}
            style={{
                width: '100%',
                position: 'relative',
                borderRadius: isMobile ? 0 : 20,
                overflow: 'hidden',
                backgroundColor: token.colorBgContainer,
                marginBottom: isMobile ? 10 : 0,
                transition: 'all 0.3s ease-in-out',
                border: isMobile ? `1px solid ${token.colorBorderSecondary}` : 'none',
                height: 'auto', // Let content determine height
                boxShadow: '0 4px 15px rgba(74, 108, 247, 0.1)',
            }}
            bodyStyle={{ padding: 0 }}
        >
            {/* Popular badge skeleton - hidden */}
            <div className="plan-popular-badge-skeleton" style={{ display: 'none' }}>
                <Skeleton.Input active size="small" style={{ width: 80 }} />
            </div>

            <div className="plan-card-header" style={{ 
                padding: isMobile ? '0.8rem 1.2rem 0.3rem' : '1rem 1.2rem 0.3rem',
            }}>
                <Skeleton.Input
                    active
                    size="small"
                    className="plan-card-title"
                    style={{ 
                        width: '50%', 
                        marginBottom: 6,
                        height: 20,
                        background: !isDarkMode ? 
                            "linear-gradient(135deg, rgba(74, 108, 247, 0.12) 0%, rgba(74, 108, 247, 0.06) 100%)" : 
                            'unset'
                    }}
                />
                <div className="plan-price-wrapper" style={{ paddingTop: '0.4rem' }}>
                    <Skeleton.Input
                        active
                        size="small"
                        className="plan-original-price"
                        style={{ 
                            width: 40, 
                            marginRight: 6, 
                            verticalAlign: 'baseline',
                            height: 14
                        }}
                    />
                    <Skeleton.Input
                        active
                        size="large"
                        className="plan-card-price"
                        style={{
                            width: screens.md ? 70 : 80,
                            height: screens.md ? 22 : 32,
                            verticalAlign: 'baseline',
                            color: token.colorPrimary,
                            marginBottom: 0
                        }}
                    />
                </div>
            </div>

            <div className="plan-card-content" style={{ 
                background: !isDarkMode ? 
                    'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(248, 250, 252, 1) 100%)' : 
                    'unset',
                padding: isMobile ? '0.8rem 1.2rem 0.8rem' : '1rem 1.2rem 1rem'
            }}>
                <Skeleton.Input
                    active
                    size="small"
                    className="plan-card-coins"
                    style={{ 
                        width: 90,
                        marginBottom: 6,
                        height: 20,
                        color: token.colorPrimary 
                    }}
                />

                <Skeleton.Input
                    active
                    size="small"
                    className="plan-card-description"
                    style={{ 
                        width: '60%',
                        color: token.colorTextSecondary,
                        marginBottom: 6,
                        height: 14
                    }}
                />

                <Space.Compact
                    block
                    style={{
                        width: '100%',
                        justifyContent: 'center',
                        margin: '10px 0'
                    }}
                >
                    {/* Minus Button */}
                    <Skeleton.Node
                        active
                        style={{
                            width: 40,
                            height: 32,
                            borderRadius: 6
                        }}
                    >
                        <span>-</span>
                    </Skeleton.Node>

                    {/* Input Number */}
                    <Skeleton.Node
                        active
                        style={{
                            width: 60,
                            height: 32,
                            borderRadius: 6
                        }}
                    >
                        <span>0</span>
                    </Skeleton.Node>

                    {/* Plus Button */}
                    <Skeleton.Node
                        active
                        style={{
                            width: 40,
                            height: 32,
                            borderRadius: 6
                        }}
                    >
                        <span>+</span>
                    </Skeleton.Node>
                </Space.Compact>
            </div>
        </Card>
    );
};